import { Component, AfterContentInit, OnInit, Input } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DossierDTO } from '../../api/plyca-dtos';
import { UserService } from '../../user.service';
import { UIService } from '../../ui.service';
import { forkJoin } from 'rxjs';
import { Configuration } from '../../conf/app.constants';
import { DossierService } from '../dossier.service';
import { PlanificationDTO, MilestoneDTO, ProjectEntityDTO } from '../../api/plyca-dtos-v2';
import { map } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import * as lodash from 'lodash';
import * as moment from 'moment';
import { PaginationDTO } from '../../api/PaginationModel';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { SelectItem } from 'primeng-lts/api';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { PRIMENG_DATE_FORMAT, LanguageService } from '../../../services/language.service';
import { TranslateService } from '@ngx-translate/core';

const dateFormat = 'dd/MM/yyyy';
const dateLocale = 'es-ES';

@Component({
  selector: 'planning',
  templateUrl: 'planning.template.html'
})
export class planningComponent extends BaseComponent implements OnInit, AfterContentInit {
  @Input() continuationPlan: boolean;
  @Input() divisionId: any;

  loading: boolean;
  ALIAS_ATTR_PLANIF = 'SEG_PLANIF_EXP_CONT_STD';
  ALIAS_ATTR_PLANIF_CONTINUATION = 'SEG_PLANIF_EXP_CONTINUACION_STD';
  showHeader: boolean;
  dossierId: string;
  dossier: DossierDTO;
  dates: Array<any>;

  public PRIMENG_DATE_FORMAT = PRIMENG_DATE_FORMAT;
  protected visualizationModes: SelectItem[];
  protected selectedVisualizationMode: string;

  protected estimationModes: SelectItem[];
  protected selectedEstimationMode: string;

  chartData: any;
  options: any;

  editObjectiveVisible: boolean = false;
  currentPlanif: PlanificationDTO;

  constructor(
    public plycaService: PlycaDataService,
    public userService: UserService,
    public dossierService: DossierService,
    public uiService: UIService,
    public route: ActivatedRoute,
    public router: Router,
    public dialogService: DialogService,
    public configuration: Configuration,
    private headerActionsService: HeaderActionsService,
    private waitService: WaitLoadingService,
    private plycaErrorHandler: PlycaErrorHandler,
    private translate: TranslateService,
    private languageService: LanguageService
  ) {
    super();
    this.subscribe(route.params, params => {
      this.dossierId = params['id'];
    });

    this.visualizationModes = [
      { label: this.translate.instant('Planning.viewModes.table'), value: 'TABLE', icon: 'fas fa-table' },
      { label: this.translate.instant('Planning.viewModes.timeline'), value: 'TIMELINE', icon: 'fas fa-stream' },
      { label: this.translate.instant('Planning.viewModes.graph'), value: 'CHART', icon: 'fas fa-chart-line' }
    ];
    this.selectedVisualizationMode = 'TABLE';
    this.estimationModes = [
      { label: this.translate.instant('Planning.calulateModes.configuration'), value: 'CONFIGURATION' },
      { label: this.translate.instant('Planning.calulateModes.historic'), value: 'HISTORIC' }
    ];
    this.selectedEstimationMode = 'CONFIGURATION';
  }

  // Temporal para annadir la / al propuestaId
  private normalizaDossierId(dossierId: string): string {
    return dossierId.substring(0, 4) + '/' + dossierId.substring(4);
  }
  startObjectiveEdit(planif: PlanificationDTO) {
    this.currentPlanif = lodash.cloneDeep(planif);
    console.log('ABRIENDO DIALOG DE EDICION', planif);
    //    this.currentPlanif = planif;
    if (this.currentPlanif.fechaObjetivo) {
      let d = moment(this.currentPlanif.fechaObjetivo.replace(/-/g, '/'), dateFormat.toUpperCase()).toDate();
      console.log('EDITANDO OBJETIVO', d);
      this.currentPlanif['fechaObjetivoDt'] = d;
    }
    this.editObjectiveVisible = true;
  }

  stopObjectiveEdit() {
    console.log('CERRANDO DIALOG DE EDICION');
    this.currentPlanif = undefined;
    this.editObjectiveVisible = false;
    this.load();
  }

  deleteFechaObjetivo() {
    this.waitService.startWaiting();
    this.editObjectiveVisible = false;

    let url = this.configuration.MILESTONES_DOSSIER_SERVICE_URL.replace(
      '{dossierId}',
      this.dossierId
    );
    this.subscribe(this.plycaService
      .query<MilestoneDTO>(url, this.getParams()),
      (param: PaginationDTO<MilestoneDTO>) => {
        console.log('HITOS DEL EXPEDIENTE ', param);
        if (param && param.content) {
          let finded = param.content.find(
            hito =>
              hito.typeMilestone.identifier ===
              'PLAN_' + this.currentPlanif.idFecha
          );
          if (finded) {
            console.log('DELETE MILESTONE', finded);
            this.subscribe(this.plycaService
              .delete<MilestoneDTO>(
                this.configuration.MILESTONES_SERVICE_URL,
                finded.identifier
              ),
              reponse => {
                console.log('HITO ELIMINADO', reponse);
                this.stopObjectiveEdit();
              });
          } else {
            console.log('NO SE HA PODIDO ELIMINAR EL HITO. HITO NO ENCONTRADO');
          }
        }
      });
  }

  setFechaObjetivo() {
    this.waitService.startWaiting();
    this.editObjectiveVisible = false;

    let date = this.currentPlanif['fechaObjetivoDt'];
    if (date) {
      if (typeof date === 'string') {
        this.currentPlanif.fechaObjetivo = date;
      } else {
        console.log(
          'ESTABLECIENDO OBJETIVO',
          this.currentPlanif.idFecha,
          '->',
          date,
          formatDate(date, dateFormat, dateLocale)
        );
        this.currentPlanif.fechaObjetivo = formatDate(date, dateFormat, dateLocale);
      }
    } else {
      console.log(
        'ESTABLECIENDO OBJETIVO',
        this.currentPlanif.idFecha,
        '->',
        date
      );
      this.currentPlanif.fechaObjetivo = undefined;
    }
    let milestone = new MilestoneDTO();
    if (typeof date === 'string') {
      milestone.dateMilestone = formatDate(moment(this.currentPlanif.fechaObjetivo).toDate(), dateFormat, dateLocale) + ' 00:00:00';
    } else {
      milestone.dateMilestone = date;
    }
    milestone.typeMilestone = {
      identifier: 'PLAN_' + this.currentPlanif.idFecha
    };
    // parchear project
    milestone.project = {} as ProjectEntityDTO;
    milestone.project.identifier = this.normalizaDossierId(
      this.dossierId
    );
    milestone.description = this.currentPlanif.description + ' (' + this.translate.instant('Planning.target') + ')';

    let url = this.configuration.MILESTONES_DOSSIER_SERVICE_URL.replace(
      '{dossierId}',
      this.dossierId
    );
    this.subscribe(this.plycaService
      .query<MilestoneDTO>(url, this.getParams()),
      (param: PaginationDTO<MilestoneDTO>) => {
        // console.log('HITOS DEL EXPEDIENTE ', param);
        let finded: MilestoneDTO;
        if (param && param.content) {
          finded = param.content.find(
            hito =>
              hito.typeMilestone.identifier ===
              milestone.typeMilestone.identifier
          );
        }
        if (!finded) {
          // console.log('NO ENCONTRADO (INSERT)');
          this.subscribe(this.plycaService
            .insert<MilestoneDTO>(
              this.configuration.MILESTONES_SERVICE_URL,
              milestone
            ),
            reponse => {
              console.log('HITO INSERTADO', reponse);
              this.stopObjectiveEdit();
            },
            (error: any) => {
              this.waitService.cancelWaiting();
              this.plycaErrorHandler.showServerError(error)
            });
        } else {
          // console.log('ENCONTRADO (UPDATE)');
          // milestone.identifier = finded.identifier;
          finded.dateMilestone = milestone.dateMilestone;
          this.subscribe(this.plycaService
            .update<MilestoneDTO>(
              this.configuration.MILESTONES_SERVICE_URL,
              finded
            ),
            reponse => {
              console.log('HITO INSERTADO', reponse);
              this.load();
            },
            (error: any) => {
              this.waitService.cancelWaiting();
              this.plycaErrorHandler.showServerError(error)
            });
        }
      });
  }

  getParams() {
    return {
      typeMilestone: 'PLAN_' + this.currentPlanif.idFecha
    };
  }

  // closeFechaObjetivo(planif: PlanificationDTO) {
  //   console.log('cerrando', planif, planif['enabled']);
  //   planif['enabled'] = false;
  // }

  // isPlanifOpen(planif: PlanificationDTO) {
  //   return planif['enabled'];
  // }

  ngOnInit() { }

  ngAfterContentInit(): void {
    this.loading = true;
    if (!this.divisionId)
      this.divisionId = "0";
    if (this.continuationPlan)
      this.visualizationModes = this.visualizationModes.filter(x => x.value !== 'CHART');
    this.load();
    this.headerActionsService.clearActions();
    this.subscribe(this.headerActionsService
      .addAction('General.reload', 'fas fa-lg fa-sync-alt', 'btn-primary', true),
      success => {
        this.load();
      });
    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService
      .addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true
      ),
      success => {
        this.uiService.routeBack();
      });
  }

  ngOnDestroy() {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoading() {
    return !this.dossier || this.loading;
  }

  load() {
    this.waitService.startWaiting();
    this.loading = true;
    this.subscribe(forkJoin(
      this.plycaService.getDossier(this.dossierId),
      this.loadDates()
    ), result => {
      this.dossier = result[0];
      this.dates = result[1];
      console.log('RESULTADO CONSULTA (subscribe): ', this.dates);
      this.loading = false;
      this.waitService.cancelWaiting();
    }, err => {
      console.log('ERROR CARGANDO PLANIFICACION')
      this.loading = false;
      this.waitService.cancelWaiting();
    });
  }

  initChart() {
    this.options = {
      scales: {
        // yAxes: [
        //   {
        //     stacked: true,
        //     ticks: {
        //       beginAtZero: true
        //       //              autoSkip: false // Mostrar label de todas las entradas
        //     }
        //   }
        // ],
        xAxes: [
          {
            ticks: {
              autoSkip: false // Mostrar label de todas las entradas
            }
          }
        ]
      },
      elements: {
        line: {
          tension: 0 // disables bezier curves
        }
      }
    };

    this.chartData = {
      labels: [],
      datasets: [
        {
          label: this.translate.instant('Planning.graph.real'),
          data: [],
          fill: false,
          borderColor: '#432010'
        },
        {
          label: this.translate.instant('Planning.graph.configuration'),
          data: [],
          fill: false,
          borderColor: '#4bc0c0'
        },
        {
          label: this.translate.instant('Planning.graph.historic'),
          data: [],
          fill: false,
          borderColor: '#0c04bc'
        }
      ]
    };
  }

  addPlanification2Chart(plan: PlanificationDTO) {
    this.chartData['labels'].push(plan.description);
    this.chartData['datasets'][0]['data'].push(plan.plazoReal);
    this.chartData['datasets'][1]['data'].push(plan.plazoConf);
    this.chartData['datasets'][2]['data'].push(plan.plazoHistorico);
  }

  columnResult2PlanifDTO(col: any): PlanificationDTO {
    let dto = new PlanificationDTO();
    dto.description = col['DESCRIPCION'] ? col['DESCRIPCION'].value : '';

    dto.diasRetrasoConf = col['DIAS_RETRASO_CONF']
      ? col['DIAS_RETRASO_CONF'].value
      : '';
    dto.diasRetrasoHistorico = col['DIAS_RETRASO_HIST']
      ? col['DIAS_RETRASO_HIST'].value
      : '';
    dto.diasRetrasoObjetivo = col['DIAS_RETRASO_OBJ']
      ? col['DIAS_RETRASO_OBJ'].value
      : '';

    dto.fechaEstimadaConf = col['FECHA_ESTIMADA_CONF']
      ? this.formatDate(col['FECHA_ESTIMADA_CONF'].value)
      : '';
    dto.fechaEstimadaHistorico = col['FECHA_ESTIMADA_HIST']
      ? this.formatDate(col['FECHA_ESTIMADA_HIST'].value)
      : '';
    dto.fechaEstimadaObjetivo = col['FECHA_ESTIMADA_OBJ']
      ? this.formatDate(col['FECHA_ESTIMADA_OBJ'].value)
      : '';

    dto.fechaObjetivo = col['FECHA_OBJETIVO']
      ? this.formatDate(col['FECHA_OBJETIVO'].value)
      : '';
    dto.fechaReal = col['FECHA_REAL']
      ? this.formatDate(col['FECHA_REAL'].value)
      : '';
    // dto.fechaReal = col['ES_FECHA_REAL'] ? col['ES_FECHA_REAL'].value : '';

    dto.idFecha = col['ID_FECHA'] ? col['ID_FECHA'].value : '';

    dto.plazoReal = col['PLAZO_REAL'] ? col['PLAZO_REAL'].value : '';
    dto.plazoConf = col['PLAZO_CONF'] ? col['PLAZO_CONF'].value : '';
    dto.plazoHistorico = col['PLAZO_HIST'] ? col['PLAZO_HIST'].value : '';

    return dto;
  }

  getStatusStyle(value) {
    let OFFSET = 5;
    return {
      'badge-danger': value >= OFFSET,
      'badge-warning': value > 0 && value < OFFSET,
      'badge-success': value <= 0
    };
  }

  private formatDate(value: string): string {
    return value.substring(0, value.indexOf(' '));
  }

  loadDates() {
    this.initChart();
    var attrib = this.continuationPlan ? this.ALIAS_ATTR_PLANIF_CONTINUATION : this.ALIAS_ATTR_PLANIF;
    return this.plycaService
      .getAttributeValue(
        attrib,
        'PROPUESTAID=' + this.dossierId + '&DIVISION=' + this.divisionId
      )
      .pipe(
        map(
          result => {
            let planifications: Array<any> = [];
            if (result.values) {
              result.values.map(row => {
                let plan = this.columnResult2PlanifDTO(row.columns);
                planifications.push(plan);
                this.addPlanification2Chart(plan);
              });
            }
            console.log('RESULTADO CONSULTA: ', planifications);
            return planifications;
          },
          err => {
            console.log('Error cargando datos atributo: ' + attrib);
            console.log(err);
          }
        )
      );
  }

  // para no gestionar objetivos de fechas de alta e inico
  esFechaConObjetivo(planif): boolean {
    return planif.idFecha !== 'FEC_INICIO' && planif.idFecha !== 'FEC_ALTA';
  }

}
